import * as Loader from './loader';
import { xml2json, json2xml } from 'mx-xml-json-converter';
import Config from './Config';

const EnvLoader = () => {
  
  var sessionStorage_transfer = function(event) {

    if(!event) { event = window.event; } // ie suq
    if(!event.newValue) return;          // do nothing if no value to work with
    if (event.key === 'getSessionStorage') {
      // another tab asked for the sessionStorage -> send it
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
      // the other tab should now have it, so we're done with it.
      localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
    } else if (event.key === 'sessionStorage' && !sessionStorage.length) {

      const alreadyLogin = atob(localStorage.getItem(btoa('login')));
      if(alreadyLogin === 'true') {
        // another tab sent data <- get it
        var data = JSON.parse(event.newValue);
        for (var key in data) {
          sessionStorage.setItem(key, data[key]);
        }
      } else {
        sessionStorage.clear();
      }

      
    }
  };

  const getIp = async function(url, settingIp) {
    const httpHeader = {};
    httpHeader.method = 'POST';
    httpHeader.headers = {
        "Content-Type": "application/json",
    };
    httpHeader.body = "?";

    return await fetch(url,httpHeader)
    .then(res => {
      if(res.ok){
        return res.text();
      }else{
        console.log("웹서비스 오류");
      }
    })
    .then(response=>{
      const utilInfo = xml2json.fromStr(response);
      const dataIp = utilInfo.root.data.CLIENT_IP;
      if (settingIp === dataIp) return "Y";
      else return "N";
      // console.log(dataIp);
      // return dataIp;
    });
  }
  
  window.addEventListener("storage", sessionStorage_transfer, false);

  // Ask other tabs for session storage (this is ONLY to trigger event)

  const alreadyLogin = atob(localStorage.getItem(btoa('login')));
  if(alreadyLogin !== 'true') {
    sessionStorage.clear();
  }

  if (!sessionStorage.length) {
    localStorage.setItem('getSessionStorage', 'foobar');
    localStorage.removeItem('getSessionStorage', 'foobar');
  };



  return new Promise(async (resolve, reject) => {
  
    const loaders = Object.values(Loader);
    Promise.all(loaders.map(f => f())).then(async res => {
      Object.assign(Config, res[0]);
      Config.isSetting = Config.isSettingIp ? await getIp(Config.wsurl, Config.isSettingIp) : 'N';
      resolve();
    }).catch(err => {
      console.error('mxV-Logger :: EnvLoader >> ', err);
    })

  })
};

export default EnvLoader;




// WEBPACK FOOTER //
// ./src/util/EnvLoader.js